import React from 'react';
export const ManifestLink = ({ crossOrigin, href, }) => {
    return React.createElement("link", { rel: "manifest", href: href, crossOrigin: crossOrigin });
};
